import type { CancelToken } from "axios";

import { clientApiCall } from "./apiCallWrapper";
import type {
  CatalogFilterRequest,
  CatalogFilterResponse,
  MarkNamesResponse,
  SectionLinkResponse,
} from "./types/catalog";

/**
 * Клиентский (браузерный) API поиска по каталогу.
 * BFF: pages/api/client/catalog/getCatalogSearch.
 */
export default (_axios: any, config: any) => ({
  getCatalogSearch(
    q: string,
    cancelToken?: CancelToken,
    isBaltex = false,
    mark: string | null = null,
    /**
     * С `format: "full"` ответ приходит как `{ items, total }`: подсказке
     * нужно общее число найденного для строки «Показать все результаты (N)».
     * Без параметра формат прежний — массив товаров.
     */
    options: { format?: "full"; suggestLimit?: number } = {},
  ) {
    const params: Record<string, unknown> = { q, isBaltex };
    if (mark) {
      params.mark = mark;
    }
    if (options.format) {
      params.format = options.format;
    }
    if (options.suggestLimit) {
      params.suggestLimit = options.suggestLimit;
    }
    return clientApiCall(
      `${config.API_SERVER_URL}/client/catalog/getCatalogSearch/`,
      {
        api: "catalog.getCatalogSearch",
        params,
        axiosConfig: cancelToken ? { cancelToken } : undefined,
      },
    );
  },

  getMarkNames(reset = false): Promise<MarkNamesResponse | null> {
    return clientApiCall<MarkNamesResponse>(
      `${config.API_SERVER_URL}/client/catalog/getMarkNames`,
      {
        api: "catalog.getMarkNames",
        skipForRobots: true,
        params: { reset },
      },
    );
  },

  /** Ссылка на раздел с учётом машины из подборщика. BFF: pages/api/client/catalog/getSectionLink. */
  getSectionLink(
    sectionId: string,
    filterUrl: string,
  ): Promise<SectionLinkResponse | null> {
    return clientApiCall<SectionLinkResponse>(
      `${config.API_SERVER_URL}/client/catalog/getSectionLink`,
      {
        api: "catalog.getSectionLink",
        params: { sectionId, filterUrl },
      },
    );
  },

  getFilter(
    params: CatalogFilterRequest,
    reset = false,
  ): Promise<CatalogFilterResponse | null> {
    return clientApiCall<CatalogFilterResponse>(
      `${config.API_SERVER_URL}/client/catalog/getFilter`,
      {
        api: "catalog.getFilter",
        skipForRobots: true,
        params: {
          data: encodeURI(JSON.stringify(params)),
          reset,
        },
      },
    );
  },
});
